import script from "./Bandcamp.vue?vue&type=script&setup=true&lang=js"
export * from "./Bandcamp.vue?vue&type=script&setup=true&lang=js"

import "./Bandcamp.vue?vue&type=style&index=0&id=d85bb1ba&lang=css"

const __exports__ = script;

export default __exports__